import { ACCESS_TYPE } from 'redesign/hooks/useCurrentLaboratory'

export const SINGLE_BRAND = {
    [ACCESS_TYPE.agendamento_com_carrinho]: {
        title: 'Vamos agendar seus exames e vacinas',
        subtitle: 'Confira as unidades e datas disponíveis com o Nav Dasa, o assistente do ',
    },
    [ACCESS_TYPE.agendamento_sem_carrinho]: {
        title: 'Vamos iniciar seu agendamento',
        subtitle: 'Para conferir datas, coberturas e valores, entre no Nav Dasa, o assistente do ',
    },
    [ACCESS_TYPE.agendamento_sem_carrinho_CIP]: {
        title: 'Vamos iniciar seu agendamento',
        subtitle: 'Para conferir datas, coberturas e valores, entre no Nav Dasa, o assistente do ',
    },
    [ACCESS_TYPE.resultado]: {
        title: 'Confira seus resultados de exames',
        subtitle: 'Acesse sua conta no Nav Dasa, o assistente do ',
    },
}
